import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// import { Delete } from '@mui/icons-material';
// import { EmptyGridCell } from '../atoms/emptyGridCell';

type OrganizationUserTableProps<T> = {
  roles: Array<T>;
  idColumn: string;
  titleColumn: string;
  valueColumn: string;
  // editCallback: (id: any) => void;
  // deleteCallback: (id: any) => void;
};

export const OrganizationUserTable = <T,>(props: OrganizationUserTableProps<T>) => {
  const { roles, idColumn, titleColumn, valueColumn } = props;
  const { t } = useTranslation(['common']);
  return (
    <TableContainer>
      <Table aria-label='simple table' size='medium'>
        <TableHead>
          <TableRow sx={{ color: (thm) => thm.palette.text.secondary, fontWeight: 500 }}>
            <TableCell>{t('common:organization.tableHeader.name')}</TableCell>
            <TableCell>{t('common:organization.tableHeader.userName')}</TableCell>
            {/* <TableCell /></TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {roles.map((row) => {
            // const isDisabled = !row[valueColumn];
            return (
              <TableRow key={row[idColumn]} hover>
                <TableCell component={'th' as any} scope='row'>
                  <Typography variant='body1' sx={{ fontWeight: 600 }}>
                    {row[titleColumn]}
                  </Typography>
                </TableCell>
                <TableCell>{row[valueColumn]}</TableCell>
                {/* <TableCell width='10%'>
                  {isDisabled && <EmptyGridCell />}
                  {!isDisabled && (
                    <IconButton size='small' onClick={() => deleteCallback(row[idColumn])}>
                      <Delete sx={{ color: (thm) => thm.palette.action.active }} />
                    </IconButton>
                  )}
                </TableCell> */}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
